import script from "./JobTechnology.vue?vue&type=script&setup=true&lang=js"
export * from "./JobTechnology.vue?vue&type=script&setup=true&lang=js"

import "./JobTechnology.vue?vue&type=style&index=0&id=e1aaf074&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1aaf074"]])

export default __exports__